import { Text, chakra, createMultiStyleConfigHelpers, useMultiStyleConfig } from '@chakra-ui/react';
import React from 'react';
const colorSchemes = {
    brand: {
        bg: 'background.brand',
        color: 'text.inverse'
    },
    cloud: {
        bg: 'background.cloud',
        color: 'text.inverse'
    },
    cyber: {
        bg: 'background.cyber',
        color: 'text.inverse'
    },
    dark: {
        bg: 'fill.translucid',
        color: 'text.inverse'
    },
    data: {
        bg: 'background.data',
        color: 'text.inverse'
    },
    interactive: {
        bg: 'fill.interactive',
        color: 'text.inverse'
    },
    light: {
        bg: 'fill.light',
        color: 'text.secondary'
    },
    pink: {
        bg: 'fill.new',
        color: 'text.inverse'
    },
    transparent: {
        bg: 'transparent',
        color: 'text.primary'
    },
    ux: {
        bg: 'background.ux',
        color: 'text.inverse'
    },
    web: {
        bg: 'background.web',
        color: 'text.inverse'
    },
    white: {
        bg: 'fill.white',
        color: 'text.secondary'
    }
};
// eslint-disable-next-line @typescript-eslint/unbound-method -- Complaining about `this` in Chakra functions?
const { defineMultiStyleConfig  } = createMultiStyleConfigHelpers([
    'container'
]);
export const tagTheme = defineMultiStyleConfig({
    baseStyle: {
        container: {
            alignItems: 'center',
            borderRadius: '8px',
            display: 'inline-flex',
            gap: 0.5,
            h: '32px',
            p: 0.5,
            w: 'min-content',
            whiteSpace: 'nowrap'
        }
    },
    variants: {
        default: ({ colorScheme  })=>({
                container: colorSchemes[colorScheme]
            })
    },
    sizes: {
        s: {
            container: {
                h: '24px'
            }
        },
        l: {
            container: {
                h: '32px'
            }
        }
    },
    defaultProps: {
        colorScheme: 'pink',
        variant: 'default',
        size: 'l'
    }
});
export const Tag = (props)=>{
    const { colorScheme , icon: Icon , size , text , uppercase =false , variant , ...badgeProps } = props;
    const styles = useMultiStyleConfig('Tag', {
        colorScheme,
        variant,
        size
    });
    return /*#__PURE__*/ React.createElement(chakra.span, {
        __css: styles.container,
        ...badgeProps
    }, Icon && /*#__PURE__*/ React.createElement("span", null, /*#__PURE__*/ React.createElement(Icon, null)), /*#__PURE__*/ React.createElement(Text, {
        textStyle: "xsBold",
        ...uppercase && {
            textTransform: 'uppercase'
        }
    }, text));
};

//# sourceMappingURL=tag.js.map